<template>
<div class="dialog">
    <div>
        <el-table
    :data="historyList.data"
    border
    style="width: 100%">
    <el-table-column
      prop="deta"
      label="建当日期"
      >
    </el-table-column>

     <el-table-column
      prop="ticketnumber"
      label="票号"
      >
    </el-table-column>

    <el-table-column
      prop="name"
      label="姓名"
      >
    </el-table-column>
   
    <el-table-column
      prop="objname"
      label="物品名称"
      >
    </el-table-column>

    <el-table-column
      prop="weight"
      label="重量/g"
      >
    </el-table-column>

     <el-table-column
      prop="startdate"
      label="开始日期"
      >
    </el-table-column>

     <el-table-column
      prop="enddate"
      label="到期日期"
      >
    </el-table-column>

    <el-table-column
      prop="price"
      label="金额"
     >
    </el-table-column>

    <el-table-column
      prop="state"
      label="业务状态"
      >
    </el-table-column>

    <el-table-column
      fixed="left"
      label="操作"
      width="100">
      <template slot-scope="scope">
        <el-button @click="handleClick(scope.row)" type="text" size="small">选择</el-button>
        
      </template>
    </el-table-column>
  </el-table>


    </div>
    
    

</div>
</template>
<script>
export default {
    name:'GetHistory',

    data(){
        return{

        }
    },

    
    props:['historyList'],

    methods:{
        handleClick(event){
            
             this.$emit("child-event", event)
        }
    },

    created(){
        
    },

    mounted() {
    
    },

}
</script>
<style scoped>
    
</style>